module.exports = __webpack_public_path__ + "img/CLP-investment.2a68dc48.png";